const AppRoutes = [
    {
        label: 'Toutes les stations',
        path: '/',
    },
    {
        label: 'Favoris',
        path: '/favorites',
    },
];

export default AppRoutes;
